import { Link, useParams } from 'react-router-dom';
import { api } from '../lib/api';
import { useAsync } from '../lib/useAsync';

export function Activities() {
  const { orgId } = useParams();
  const org = useAsync(() => api.orgs.get(orgId!), [orgId]);
  const list = useAsync(() => api.activities.list(orgId!), [orgId]);
  return (
    <>
      <div className="row between">
        <h1>{org.data?.name ?? '…'} <span className="muted" style={{ fontWeight: 400 }}>· Activities</span></h1>
        <Link to={`/orgs/${orgId}/activities/new`}><button className="primary">New activity</button></Link>
      </div>
      {list.error && <p className="err">{list.error}</p>}
      {list.data && list.data.length === 0 && <div className="empty">No activities yet. Create the first poll or quiz.</div>}
      {list.data && list.data.length > 0 && (
        <table>
          <thead><tr><th>Title</th><th>Type</th><th>Status</th><th>Versions</th><th>Window</th><th>Updated</th></tr></thead>
          <tbody>
            {list.data.map((a) => (
              <tr key={a.id}>
                <td><Link to={`/orgs/${orgId}/activities/${a.id}`}><b>{a.title}</b></Link><div className="muted">{a.slug}</div></td>
                <td>{a.type}</td>
                <td><span className={`pill ${a.status}`}>{a.status}</span></td>
                <td>{a.versions.length}{a.currentVersionId ? ` · live v${a.versions.find((v) => v.id === a.currentVersionId)?.versionNo ?? '?'}` : ''}</td>
                <td className="muted">{fmt(a.opensAt)} → {fmt(a.closesAt)}</td>
                <td className="muted">{new Date(a.updatedAt).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
}

export const fmt = (iso: string | null | undefined) => (iso ? new Date(iso).toLocaleString() : 'open');
